module.exports = __webpack_public_path__ + "assets/img/88syt.8af6b319.svg";